export default "/assets/images/problem-solved-04.e92ad63aaa4982f4.webp";